/*
 * @Author: 孙兴隆
 * @description 接口文件
 */
import request from '../../../../api/index';

export default class {
  //获取模板详情
  static EditTreeList = (params) => {
    return request('get', `module/edit`, params)
  }
  //保存模板
  static SaveDateList = (params) => {
    return request('post', `module/save`, params)
  }
  //删除列表接口
  static DeleteDateList = (params) => {
    return request('get', `article/delete`, params)
  }
}

